import React, { useEffect } from 'react'
import {Row, Col, Button} from 'reactstrap';

const KakaoShareButton = () => {

  const createKakaoButton = () => {
    // kakao sdk script이 정상적으로 불러와졌으면 window.Kakao로 접근이 가능합니다
    if (window.Kakao) {
      const kakao = window.Kakao

      // 중복 initialization 방지
      if (!kakao.isInitialized()) {
        // 두번째 step 에서 가져온 javascript key 를 이용하여 initialize
        kakao.init("1ffba65e6b6ae6b3c6d319abb6f03d4b")
      }

      kakao.Link.sendDefault({
        objectType: 'feed',
        content: {
          title: "규범❤️규영",
          description: "2022년 10월 03일 월요일 11시 @마리아쥬 스퀘어",
          imageUrl: "https://felixo9.synology.me/static/media/page001.16d1007f9f50bee99135.png",
          link: {
            mobileWebUrl: "https://felixo9.synology.me",
            webUrl: "https://felixo9.synology.me",
          },
        }
      })
    }
  }

  return (             
    <Button color="secondary" 
        size="lg" 
        block 
        style={{fontSize:"medium"}}
        onClick={()=>createKakaoButton()}
    > 
    카카오톡으로 공유하기
    </Button>)
}

export default KakaoShareButton